import { ObjectMapper, JsonProperty } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class ApplicantDocumentsDownloadModel
  extends Model
  implements IModel<ApplicantDocumentsDownloadModel>
{
  @JsonProperty({ name: 'processedInBackground' })
  ProcessedInBackground: boolean = false;

  @JsonProperty({ name: 'downloadUrl' })
  DownloadUrl: string = '';

  static create(input: any): ApplicantDocumentsDownloadModel {
    return ObjectMapper.deserialize<ApplicantDocumentsDownloadModel>(
      ApplicantDocumentsDownloadModel,
      input
    );
  }
}
